import { render } from "./MemberProfile.vue?vue&type=template&id=3579b3ca&scoped=true"
import script from "./MemberProfile.vue?vue&type=script&lang=js"
export * from "./MemberProfile.vue?vue&type=script&lang=js"

import "./MemberProfile.vue?vue&type=style&index=0&id=3579b3ca&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3579b3ca"]])

export default __exports__